module.exports = __webpack_public_path__ + "static/media/EarthSm.a5601702.jpg";